import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  getClasses,
  getStudentsFeesByClass,
  updateStudentFeeStatus,
} from "../api/services";

function AdminFees() {
  const [classes, setClasses] = useState([]);
  const { t } = useTranslation();
  const [students, setStudents] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");

  const [loading, setLoading] = useState(false);

  // load classes
  useEffect(() => {
    fetchClasses();
  }, []);

  const fetchClasses = async () => {
    try {
      const res = await getClasses();
      setClasses(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to load classes");
    }
  };

  // load students when class changes
  const handleClassChange = async (classId) => {
    setSelectedClass(classId);
    setStudents([]);

    if (!classId) return;

    try {
      const res = await getStudentsFeesByClass(classId);
      setStudents(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to load students");
    }
  };

  // toggle fee status
  const toggleFee = async (student) => {
    try {
      const newStatus = !student.fees_cleared;

      await updateStudentFeeStatus({
        student_id: student.id,
        fees_cleared: newStatus,
      });

      setStudents((prev) =>
        prev.map((s) =>
          s.id === student.id ? { ...s, fees_cleared: newStatus } : s
        )
      );
    } catch (err) {
      console.error(err);
      alert("Failed to update fee status");
    }
  };

  return (
    <div style={styles.page}>
      <h1 style={styles.title}>{t("studentFeeClearance")}</h1>
      <p style={styles.subtitle}>
        {t("studentFeeClearanceText")}
      </p>

      <div style={styles.card}>
        {/* Class Selector */}
        <div style={styles.field}>
          <label style={styles.label}>{t("chooseClass")}</label>

          <select
            style={styles.select}
            value={selectedClass}
            onChange={(e) => handleClassChange(e.target.value)}
          >
            <option value="">-- Choose Class --</option>

            {classes.map((c) => (
              <option key={c.id} value={c.id}>
    {c["department__name"]
        ? `${c.name} (${c["department__name"]})`
        : c.name}
</option>
            ))}
          </select>
        </div>

        {/* Students Table */}

        {students.length > 0 && (
          <div style={styles.tableBox}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.thLeft}>{t("student")}</th>
                  <th style={styles.thCenter}>{t("feesCleared")}</th>
                </tr>
              </thead>

              <tbody>
                {students.map((student) => (
                  <tr key={student.id}>
                    <td style={styles.nameCell}>
                      {student.first_name} {student.last_name}
                    </td>

                    <td style={styles.checkCell}>
                      <input
                        type="checkbox"
                        checked={student.fees_cleared}
                        onChange={() => toggleFee(student)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {selectedClass && students.length === 0 && (
          <p>{t("noStudentsFound")}</p>
        )}
      </div>
    </div>
  );
}

/* ---------- Styles ---------- */

const styles = {
  page: {
    padding: "7px",
    fontFamily: "Inter, Segoe UI, sans-serif",
    background: "#f8fafc",
    minHeight: "100vh",
  },

  title: {
    marginBottom: "6px",
  },

  subtitle: {
    color: "#64748b",
    marginBottom: "20px",
  },

  card: {
    background: "white",
    padding: "24px",
    borderRadius: "14px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
    maxWidth: "700px",
  },

  field: {
    marginBottom: "20px",
  },

  label: {
    display: "block",
    marginBottom: "6px",
    fontWeight: "600",
  },

  select: {
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    width: "100%",
  },

  tableBox: {
    marginTop: "20px",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
  },

  thLeft: {
    textAlign: "left",
    padding: "12px",
    background: "#f1f5f9",
  },

  thCenter: {
    textAlign: "center",
    padding: "12px",
    background: "#f1f5f9",
  },

  nameCell: {
    padding: "10px",
    borderTop: "1px solid #e2e8f0",
  },

  checkCell: {
    textAlign: "center",
    borderTop: "1px solid #e2e8f0",
  },
};

export default AdminFees;